// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/docker-35e621d613051bbda5b8b67fc5bb152e/css/" + chunkId + ".css";
};